export const CHANNEL_LABELS = {
  'webchat-progresol-plus-app': 'W P. PLUS',
  'webchat-cantera': 'W CANTERA',
  'whatsapp-organico': 'WEBS RMX',
  'whatsapp-capacitaciones': 'PAID VIGUETAS',
  'whatsapp-pauta': 'PAID RMX',
  'messenger-messenger': 'FACEBOOK',
} as const;

export type ChannelKey = keyof typeof CHANNEL_LABELS;
